import MyButton from "./MyButton";
import ErrorModal from "./ErrorModal";
import MyModal from "./MyModal";
import ConfirmModal from "./ConfirmModal";
import PreLoader from "./PreLoader";
import VkAppRedirectModal from "./VkAppRedirectModal";
import CookieBanner from "./CookieBanner";

export default [
    MyButton,
    ErrorModal,
    MyModal,
    ConfirmModal,
    PreLoader,
    VkAppRedirectModal,
    CookieBanner
]
